<template>
  <div class='home'>
    <div class="banner">
      <img :src="require('@/assets/home-bg.png')" />
    </div>
    <div class="business">
      <img :src="require('@/assets/business-bg.png')" />
    </div>
    <div class="business-range">
      <div class="en-title">scope of business</div>
      <div class="chs-title">业务范围</div>
    </div>
    <div class="business-range-list">
      <div class="item" v-for="(item, index) in items1" :key="index">
        <img :src="item.url">
        <span>{{item.text}}</span>
      </div>
    </div>
    <div class="we-do1">
      <div class="desc">
        <p class="thmub">我们做什么</p>
        <p>专注为企业规划、设计、落地实施</p>
        <p>互联网架构，解决企业品牌、产品、文化</p>
        <p>如何实现真正的互联网+</p>
      </div>
      <img :src="require('@/assets/wedo1.png')" width="744" height="294" style="margin-left: 32px;" />
    </div>
    <div class="we-do2">
      <div class="desc">
        <p class="thmub">痛点解决：什么是真正的互联网+？</p>
        <p>1、解决线下产品怎么真正在互联网上运营的问题+</p>
        <p>2、解决公域流量乱烧钱没效果的问题+</p>
        <p>3、解决企业互联网公域、私域整体架构设计、完美融合问题+</p>
        <p>4、满足大数据积累成为巨大财富的需求+</p>
        <p>5、满足互联网粉丝裂变成长的需求+</p>
      </div>
      <img :src="require('@/assets/wedo2.png')" width="744" height="294" style="margin-right: 32px;" />
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      items1: [
        { url: require('@/assets/range0.png'), text: 'APP项目开发', },
        { url: require('@/assets/range1.png'), text: '应用系统开发', },
        { url: require('@/assets/range2.png'), text: '小程序开发', },
        { url: require('@/assets/range3.png'), text: '网站建设', },
        { url: require('@/assets/range4.png'), text: '微信公众号开发', },
      ],
    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style scoped lang='less'>
.home {
  min-height: calc(100vh - 61px - 150px);
  .banner {
    img {
      display: block;
      width: 100%;
      height: 374px;
    }
  }
  .business {
    background-color: #0861cc;
    img {
      width: 100%;
      height: 180px;
    }
  }
  .business-range {
    width: 1400px;
    margin: 100px auto 60px;
  }
  .business-range-list {
    display: grid;
    grid-template-columns: repeat(5, 252px);
    justify-content: center;
    grid-column-gap: 35px;
    max-width: 1520px;
    padding-bottom: 100px;
    margin: 0 auto 100px;
    border-bottom: 1px solid #b4cff0;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 252px;
      height: 210px;
      background-color: #f2f2f2;
      img {
        width: 100px;
        height: 100px;
        margin-bottom: 16px;
      }
      span {
        color: #000000;
        font-size: 23px;
        font-weight: bold;
      }
    }
  }
  .we-do1,
  .we-do2 {
    display: flex;
    width: 1520px;
    margin: 0 auto 120px;
    img {
      flex: 1;
      border-radius: 4px;
    }
    .desc {
      flex: 1;
      .thmub {
        display: inline-block;
        min-width: 291px;
        font-size: 30px;
        font-weight: bold;
        color: #db1b1b;
        padding-bottom: 16px;
        margin-bottom: 30px;
        border-bottom: 2px solid #db1b1b;
      }
      p {
        font-size: 26px;
        line-height: 40px;
        color: #000000;
        text-align: left;
      }
    }
  }
  .we-do2 {
    flex-direction: row-reverse;
  }
}
</style>
